function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sep3_Icons_1_",
  transform: "translate(-216.000000, -1947.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Illustrator",
  transform: "translate(0.000000, 1919.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#2684FF",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-path",
  fill: "#0052CC",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  points: "20 0 30 0 30 10 20 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.6430871,26.209034 C9.85701553,21.2926397 14.0585427,21.1467133 19.0021797,23.4045932 C20.3763528,24.0280971 21.9028983,24.7046651 22.6704036,25.0442757 C22.950413,25.1647895 23.0759775,25.4741231 22.9525747,25.7394162 L21.2059358,29.4539072 C21.1444632,29.5851972 21.0290784,29.6874918 20.8860787,29.7374771 C20.743079,29.7874623 20.5846487,29.7808792 20.4468956,29.719228 L16.8097106,28.0928116 C14.1742328,26.9094809 12.7125867,26.6335472 11.2594057,28.888774 C11.0534208,29.2098121 10.8643662,29.5096246 10.7176373,29.7404537 C10.6403264,29.8627736 10.5140091,29.9507738 10.3670453,29.9846971 C10.2200816,30.0186204 10.0647856,29.9956243 9.93602343,29.9208718 L6.26779958,27.7983055 C6.00621861,27.6463438 5.92215466,27.325449 6.07874497,27.076633 C6.25369103,26.8166186 6.45967591,26.490274 6.6430871,26.209034 Z M23.3573396,16.7973798 C20.1455436,21.702034 15.9468041,21.8530687 10.9951677,19.6007964 C9.6219064,18.9781093 8.09637379,18.3024276 7.32937772,17.9632619 C7.04955412,17.842906 6.92407287,17.5339776 7.04739388,17.2690321 L8.79287389,13.5594071 C8.85430565,13.4282891 8.96961387,13.3261285 9.11251872,13.2762088 C9.25542358,13.226289 9.41374875,13.2328635 9.55141044,13.2944339 L13.1749029,14.9107705 C15.808632,16.092551 17.2693083,16.3681232 18.7215251,14.1158508 C18.9273733,13.7952333 19.1163025,13.4958135 19.2629341,13.2652868 C19.3410462,13.1379551 19.4719243,13.0468238 19.6242996,13.0136656 C19.776675,12.9805073 19.9368614,13.0083003 20.0665881,13.0904045 L23.7323781,15.2101902 C23.9937855,15.3619529 24.0777937,15.6824273 23.9213073,15.9309174 C23.7464773,16.1905911 23.5406291,16.5165082 23.3573396,16.7973798 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
})))));

var SvgConfluence = function SvgConfluence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfluence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confluence.31cf654e.svg";
export { ForwardRef as ReactComponent };